import { Handshake, Home, RestorePage } from "@mui/icons-material";
import debounce from "lodash/debounce";
import React, { useCallback, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import ReusableTable from "../../../../components/custom/data_table/ReusableTable";
import IconBreadcrumbs from "../../../../components/custom/IconBreadcrumbs";
import Loader from "../../../../components/custom/Loader";
import AdminFullFormAgreement from "../../../../components/full-form-admin/AdminFullFormAgreement";
import RestoreApplication from "../../../../components/restore_application/RestoreApplication";
import SubmittedCommon from "../../../../components/SubmittedCommon";
import { useAuthorized } from "../../../../hooks/useAuthorized";
import {
  useGetCorrectionSentAgreementQuery,
  useGetCorrectionSentCopyrightQuery,
} from "../../../../redux/api/submittedCopyrightAgreementApiSlice";
import { accessRoles } from "../../../../utils/accessRoles";
import { useAuth } from "../../../../utils/authorization";
import { localDateFormat } from "../../../../utils/dateFormat";
import { detailsUrlAgreement } from "../../../../utils/detailsLink";

const LetterCorrectionSentAgreement = () => {
  const { hasRole, user } = useAuthorized();
  const applicationPath = {
    copyright: "/admin/letter-of-correction-sent-copyright",
    agreement: "/admin/letter-of-correction-sent-agreement",
  };
  const detailsRoute = "/admin/applications-tracking?regTrack=";
  const pageTitle = "সংশোধনের জন্য প্রেরিত";

  const [previewData, setPreviewData] = useState("");
  const [preview, setPreview] = useState(false);
  const [date, setDate] = useState("");
  const [category_id, setCategoryId] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const { authUser } = useAuth();

  // for modal
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  const { data, isLoading, refetch } = useGetCorrectionSentAgreementQuery({
    date,
    trackReg: searchValue,
    category_id,
    subCategory,
    page,
    fileStatus: "",
  });

  /// copyright application length
  const { data: copyright } = useGetCorrectionSentCopyrightQuery({
    date: "",
    trackReg: "",
    category_id: "",
    subCategory: "",
    page: "",
  });
  /// agreement application length
  const { data: agreement } = useGetCorrectionSentAgreementQuery({
    date: "",
    trackReg: "",
    category_id: "",
    subCategory: "",
    page: "",
    fileStatus: "",
  });

  const total = {
    copyright: copyright?.data?.length ?? 0,
    agreement: agreement?.data?.length ?? 0,
  };

  const breadcrumbsData = [
    { icon: Home, title: "হোম", url: "/" },
    {
      icon: Handshake,
      title: pageTitle ? "চুক্তিপত্র - " + pageTitle : "চুক্তিপত্র আবেদন পত্র",
      active: true,
    },
  ];

  // data table start
  const totalData = data?.meta?.total;
  const lastPage = data?.meta?.last_page;

  const debouncedSearch = useCallback(
    debounce((value) => {
      setPage(1);
      setSearchValue(value);
      refetch();
    }, 400),
    []
  );

  useEffect(() => {
    // Cleanup function to cancel the debounce when the component unmounts or debouncedSearch changes
    return () => {
      debouncedSearch?.cancel();
    };
  }, [debouncedSearch]);

  const handleSearchChange = (value) => {
    setSearchText(value);
    debouncedSearch(value);
  };

  const handlePageChange = (page) => {
    setPage(page);
    refetch();
  };

  const columns = [
    {
      label: "আবেদন নং",
      name: "trackReg",
      options: {
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData.id;
          return (
            <Link
              className="text-primary"
              to={
                user?.data?.id === 1
                  ? `${detailsRoute}${tableMeta.rowData?.trackReg}`
                  : `/admin/letter-of-correction-sent-agreement-details/${id}`
              }
            >
              {value}
            </Link>
          );
        },
      },
    },
    {
      label: "শিরোনাম",
      name: "workTitle",
    },
    { label: "বিভাগ", name: "category" },
    { label: "উপবিভাগ", name: "subCategory" },
    { label: "প্রেরণকারী", name: "applicant" },
    { label: "প্রেরণের তারিখ", name: "sendDate" },

    {
      label: "ক্রিয়াকলাপ",
      name: "id",
      options: {
        customBodyRender: (value, tableMeta) => {
          const trackReg = tableMeta.rowData.trackReg;
          const item = tableMeta.rowData.item;
          return (
            <>
              <span
                onClick={() => {
                  setPreviewData({
                    id: value,
                    trackReg: trackReg,
                  });
                  setPreview(true);
                }}
              >
                <FaEye className="text-primary fs-4 cursor-pointer" />
              </span>

              {hasRole([accessRoles.CopyrightAdmin]) && (
                <span
                  onClick={() => {
                    setModalData(item);
                    setOpenModal(true);
                  }}
                >
                  <RestorePage className="text-secondary fs-4 cursor-pointer  mx-2" />
                </span>
              )}
            </>
          );
        },
      },
    },
  ];

  const dataTable = data?.data.map((item, i) => ({
    sendDate: localDateFormat(item?.correction?.send_date),
    trackReg: item?.trackReg,
    id: item?.id,

    applicant: (
      <span>
        {item?.correction?.sendBy?.name} <br />{" "}
        {item?.correction?.sendBy?.role?.bnName}
      </span>
    ),
    workTitle: item?.document?.workTitle,
    category: item?.document?.category?.name,
    subCategory: item?.document?.subCategory?.name,
    item: item,
  }));

  if (isLoading) {
    return <Loader />;
  }
  const onPreview = () => {
    setPreview(false);
    setPreviewData("");
  };
  return (
    <div>
      <div className="py-3">
        <IconBreadcrumbs breadcrumbs={breadcrumbsData} />
      </div>
      <div className="slideUp dashboard-layout p-3">
        <div className="pb-3">
          <SubmittedCommon
            preview={preview}
            onPreview={onPreview}
            total={total}
            applicationPath={applicationPath}
            date={date}
            setDate={setDate}
            category_id={category_id}
            setCategoryId={setCategoryId}
            subCategory={subCategory}
            setSubCategory={setSubCategory}
          />
        </div>
        <div>
          {!previewData && !preview ? (
            <ReusableTable
              title={"চুক্তিপত্র আবেদন"}
              columns={columns}
              data={dataTable}
              isLoading={isLoading}
              currentPage={page}
              lastPage={lastPage}
              totalData={totalData}
              onSearchChange={handleSearchChange}
              searchText={searchText}
              onPageChange={handlePageChange}
            />
          ) : (
            <div>
              <AdminFullFormAgreement info={previewData} />

              <div className="text-center">
                <Button
                  size="sm"
                  variant="danger"
                  className="px-3"
                  onClick={onPreview}
                >
                  বন্ধ করুন
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <RestoreApplication
        appTitle={"চুক্তিপত্র"}
        open={openModal}
        data={modalData}
        onClose={() => {
          setOpenModal(false);
          setModalData(null);
        }}
      />
    </div>
  );
};

export default LetterCorrectionSentAgreement;
